import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TradeClosedRs } from '../../../interfaces/service.response';
import { MainUIServiceService } from "../../../services/main-uiservice.service";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import *  as html2canvas from 'html2canvas';  
import * as $ from "jquery";
import { Utils } from '../../../utils';
import { ShareProvider, ShareService } from '../../../services/share.service';


@Component({
    selector: 'tradeclosed-info',
    template: require('./tradeclosed-info.component.html'),
    styles: [require('./tradeclosed-info.component.css')]
})
export class  TradeClosedInfoComponent {

    FillPrice: number = 0;
    Pips: number = 0;
    Profit: number = 0;
    Qty: number = 0;
    Symbol: string = '';
    constructor(
        private router: Router,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        private dataService: DataService,
        public shareService: ShareService
    ) {

    }
}



export function ShowTradeClosedModal(modalService: NgbModal, tradeclosed: any): void {

    let m: NgbModalRef = modalService.open(TradeClosedInfoComponent, {
        backdrop: "static",
        size: "sm",
        centered: true,
        windowClass: "dark-modal"
    });
    let modal = (<TradeClosedInfoComponent>m.componentInstance);
    modal.FillPrice = tradeclosed.FillPrice;
    modal.Pips = tradeclosed.Pips;
    modal.Profit = tradeclosed.Profit;
    modal.Qty = tradeclosed.Qty;
    modal.Symbol = tradeclosed.Symbol;

}
